import styled from 'styled-components';

const CloseIcon = styled.div`
  cursor: pointer;
`;

export default {
  CloseIcon,
};
